import { Button } from "@/components/ui/button";
import { Play, Loader2 } from "lucide-react";

interface RunPlanButtonProps {
  loading: boolean;
  onClick: () => void;
  elapsed?: number;
}

export default function RunPlanButton({ loading, onClick, elapsed }: RunPlanButtonProps) {
  return (
    <Button
      size="lg"
      onClick={onClick}
      disabled={loading}
      className="min-w-[160px]"
    >
      {loading ? (
        <>
          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          Running{elapsed ? ` (${Math.floor(elapsed / 1000)}s)` : "..."}
        </>
      ) : (
        <>
          <Play className="h-4 w-4 mr-2" />
          Run Plan
        </>
      )}
    </Button>
  );
}
